// extracted by mini-css-extract-plugin
export default {"header":"list_header__lmidW","headerTitle":"list_headerTitle__SmgPr","contentBlock":"list_contentBlock__2pbOt"};